import { Box, Modal, Typography } from "@mui/material";
import { IModalProductionLines } from "./ModalProductionLinesInterfaces";
import { useStyles, getModalStyles } from "./ModalProductionLines.styles";

export const ModalProductionLines = ({ open, handleClose, title, children, alignTop = false }: IModalProductionLines) => {
    const classes = useStyles();
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={getModalStyles(alignTop)}>
                <Typography className={classes.modalTitle}>{title}</Typography>
                <Box className={classes.bodyContainer}>{children}</Box>
            </Box>
        </Modal>
    );
};
